import React from "react";
import { Stack, Typography } from "@mui/material";
import {
  getProductCategory,
  getProductData,
  getProductStageList,
} from "../../../services/Product/ProductService/productService";
import Grid from "@mui/material/Grid";
import { userHasOneOfTheseRoles, userHasRole } from "../../../services/backofficeUserService";
import { Roles } from "../../../types/BackofficeUser";
import { useCurrentUser } from "../../../provider/CurrentUserProvider";
import InsuranceData from "../CaseProgressBar/InsuranceData";
import { ProductUnion } from "../../../types/ProductUnion";
import { getPartnerDisplayName } from "../../../services/partnerReferenceService";
import usePartnerRegistry from "../../../hooks/usePartnerRegistry";

type CaseSubBarInfoProps = {
  product: ProductUnion;
};

function CaseSubBarInfo({ product }: CaseSubBarInfoProps) {
  const currentUser = useCurrentUser();
  const { partnerRegistry } = usePartnerRegistry();
  const stageList = getProductStageList(product);

  if (!stageList) {
    return null;
  }

  const statusAndPaymentType = [];

  if (!userHasOneOfTheseRoles(currentUser, [Roles.external, Roles.callcenter])) {
    statusAndPaymentType.push(`Status: ${stageList[product.stage!].label || ""}`);
  }
  if (!userHasRole(currentUser, Roles.external)) {
    statusAndPaymentType.push(
      `Zahlart: ${getProductData(product.productClassName, "paymentType." + product.paymentType, product.paymentType)}`
    );
  }

  const productCategory = getProductCategory({
    productClassName: product.productClassName,
    productCategory: getProductData(product.productClassName, "productCategory"),
  });

  const additionalInformation = getProductData(
    product.productClassName,
    "caseSubBarAdditionalInformation"
  )({ product, currentUser });

  return (
    <Grid
      container
      sx={{
        justifyContent: "space-between",
        alignItems: "end",
        margin: "1rem 0rem"
      }}>
      <Grid>
        <Stack>
          {userHasRole(currentUser, Roles.callcenter) && <Typography>Unser Zeichen: {product.reference}</Typography>}
          {userHasRole(currentUser, Roles.callcenter) && <Typography>Rechtsbereich: {productCategory}</Typography>}
          {!!statusAndPaymentType.length && <Typography>{statusAndPaymentType.join(" | ")}</Typography>}
          {product.acquisitionPartner && (
            <Typography>
              Kooperationspartner: {getPartnerDisplayName(product.acquisitionPartner, partnerRegistry)}
            </Typography>
          )}
        </Stack>
      </Grid>
      {!userHasOneOfTheseRoles(currentUser, [Roles.external]) && !!product.caseInsurance.insurer && (
        <Grid>
          <Stack sx={{
            alignItems: "flex-end"
          }}>
            {additionalInformation}
            <InsuranceData product={product} />
          </Stack>
        </Grid>
      )}
    </Grid>
  );
}

export default CaseSubBarInfo;
